// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"SearchLinkCell_tooltip__1jIAp"};